import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook, Twitter } from "lucide-react";

const COLS = [
    {
        title: "Shop",
        links: [
            { to: "/shop", label: "All Flavors" },
            { to: "/build-a-box", label: "Build a Box" },
            { to: "/catering", label: "Catering & Events" },
            { to: "/track", label: "Track Order" },
        ],
    },
    {
        title: "Company",
        links: [
            { to: "/about", label: "Our Story" },
            { to: "/reviews", label: "Reviews" },
            { to: "/faq", label: "FAQ" },
            { to: "/contact", label: "Contact" },
        ],
    },
    {
        title: "Policies",
        links: [
            { to: "/policy/shipping", label: "Shipping & Pickup" },
            { to: "/policy/refund", label: "Refund & Cancellation" },
            { to: "/policy/privacy", label: "Privacy Policy" },
            { to: "/policy/terms", label: "Terms & Conditions" },
        ],
    },
];

export default function Footer() {
    return (
        <footer className="mt-24 bg-roast text-cream-100">
            <div className="mx-auto max-w-7xl px-5 py-16 lg:px-8">
                <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-4">
                    <div>
                        <div className="flex items-center gap-2">
                            <span className="grid h-9 w-9 place-items-center rounded-full bg-banana">
                                <span className="font-serif text-lg font-bold text-roast">S</span>
                            </span>
                            <span className="font-serif text-2xl font-semibold text-cream-50">
                                Sweet <span className="italic text-banana">Pearls</span>
                            </span>
                        </div>
                        <p className="mt-4 max-w-xs text-sm leading-relaxed text-cream-100/70">
                            Rich, creamy, handcrafted banana pudding — made fresh in small batches to turn every spoonful into something special.
                        </p>
                        <div className="mt-5 flex gap-3">
                            {[Instagram, Facebook, Twitter].map((Icon, i) => (
                                <a key={i} href="#" className="grid h-10 w-10 place-items-center rounded-full bg-cream-50/10 text-cream-50 transition-colors hover:bg-banana hover:text-roast" aria-label="Social">
                                    <Icon size={18} />
                                </a>
                            ))}
                        </div>
                    </div>
                    {COLS.map((col) => (
                        <div key={col.title}>
                            <h4 className="font-serif text-lg text-banana">{col.title}</h4>
                            <ul className="mt-4 space-y-2.5">
                                {col.links.map((l) => (
                                    <li key={l.to}>
                                        <Link to={l.to} className="text-sm text-cream-100/70 transition-colors hover:text-cream-50">
                                            {l.label}
                                        </Link>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>
                <div className="mt-14 flex flex-col items-center justify-between gap-4 border-t border-cream-50/10 pt-6 text-xs text-cream-100/50 sm:flex-row">
                    <p>© {new Date().getFullYear()} Sweet Pearls. Handcrafted with love.</p>
                    <p>Pickup · Local Delivery · Nationwide Shipping</p>
                </div>
            </div>
        </footer>
    );
}
